<template>
  <div class="login_start without-header">
    <LoginStart />
  </div>
  <Copyright />
</template>

<script>
// @ is an alias to /src
import LoginStart from '@/components/Login_start.vue'
import Copyright from '@/components/copyright.vue'

export default {
  name: 'Home',
  components: {
    LoginStart,
    Copyright,
  },
}
</script>
